import { FormLabel } from '@mui/material'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FlexBox } from 'components/Box'
import { BoxForm, RadioGroup } from 'components/Form'
import Tooltip from 'components/Tooltip'
import { useMediaTypesKindOptions } from 'features/inventory/ad-unit/forms/GeneralForm/sections/MediaTypesSection/hooks/useMediaTypesKindOptions'
import { useAbility } from 'providers/casl'
import { CONTAINER_SPACING } from 'providers/material-ui/theme/constants'
import { Schema } from '../../schema'
import { DefaultFields } from './components/DefaultFields'
import { ViewportsTable } from './components/ViewportsTable/ViewportsTable'

export const RefreshSizesSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/adUnit', {
    keyPrefix: 'form.refresher.refreshRedirect.columns.refreshSizes',
  })
  const { control } = useFormContext<Schema>()
  const ability = useAbility()
  const cannotUpdateAdUnit = ability.cannot('update', 'AdUnit')
  const kindOptions = useMediaTypesKindOptions()

  const kind = useWatch({
    control,
    name: 'refreshRedirect.mediaTypeRefreshers.kind',
  })

  return (
    <BoxForm>
      <FlexBox axis='x'>
        <FormLabel>{t('label')}</FormLabel>
        <Tooltip content={t('tooltip')} />
      </FlexBox>

      <BoxForm
        sx={{
          ml: CONTAINER_SPACING,
        }}
      >
        <RadioGroup
          control={control}
          disabled={cannotUpdateAdUnit}
          label={t('kind.label')}
          name='refreshRedirect.mediaTypeRefreshers.kind'
          options={kindOptions}
          row
        />

        {kind === 'default' ? <DefaultFields /> : <ViewportsTable />}
      </BoxForm>
    </BoxForm>
  )
}
